__turbopack_context__.v({
  "article__byline": "YiOBSa_article__byline",
  "article__caption": "YiOBSa_article__caption",
  "article__content": "YiOBSa_article__content",
  "article__factbox": "YiOBSa_article__factbox",
  "article__gallery": "YiOBSa_article__gallery",
  "article__header": "YiOBSa_article__header",
  "article__header--portrait": "YiOBSa_article__header--portrait",
  "article__header-content": "YiOBSa_article__header-content",
  "article__image": "YiOBSa_article__image",
  "article__image--full": "YiOBSa_article__image--full",
  "article__images": "YiOBSa_article__images",
  "article__lead": "YiOBSa_article__lead",
  "article__list": "YiOBSa_article__list",
  "article__main-image": "YiOBSa_article__main-image",
  "article__preamble": "YiOBSa_article__preamble",
  "article__separator": "YiOBSa_article__separator",
  "article__sub-title": "YiOBSa_article__sub-title",
  "article__text": "YiOBSa_article__text",
  "article__title": "YiOBSa_article__title",
  "article__title--small": "YiOBSa_article__title--small",
});
